<template>
    <v-card class="notes-page__user-item px-4 px-sm-8 py-3 py-sm-6 elevation-0" @click="handleClick">
        <Avatar class="mr-3 mr-sm-7" :size="avatarSize" :avatar="user.user_logo" />
        <v-card-text class="notes-page__user-item-info">
            <span class="notes-page__user-item-username mb-1">
                {{ user.visible_username }}
            </span>
            <span class="notes-page__user-item-row">
                {{ user.second_profile_row }}
            </span>
            <span class="notes-page__user-item-row mb-1">
                {{ user.third_profile_row }}
            </span>
            <span v-if="user.location_profile_row" class="notes-page__user-item-location">
                {{ user.location_profile_row}}
            </span>
        </v-card-text>
        <v-radio-group class="notes-page__user-item-radio" v-model="selectedUser">
            <v-radio :value="user.user_id" />
        </v-radio-group>
        <div v-if="modalIsOpen">
			<NoteFormModal
				v-on:closeModal="handleClose"
				:show="modalIsOpen"
				:id="user.user_id"
                :username="user.visible_username"
			/>
		</div>
    </v-card>
</template>

<script>
import Avatar from '../Avatar'
import NoteFormModal from '../Modals/NoteFormModal.vue'

export default {
    components: {
        Avatar,
        NoteFormModal
    },
    props: {
        user: {
            type: Object,
            default: () => {}
        },
        selectedUser: {
            type: Number,
            default: null
        }
    },
    methods: {
        handleClick() {
            this.$emit('selectUser', this.user.user_id)
        },
        handleClose() {
            this.$emit('selectUser', null)
        }
    },
    computed: {
        modalIsOpen() {
            return this.selectedUser === this.user.user_id
        },
        avatarSize() {
            return this.$vuetify.breakpoint.xs ? '41' : '68'
        }
    },
}
</script>

<style lang="scss">
.notes-page {
    &__user-item {
        background: #FBFBFB !important;
        border: 1px solid #E2E2E2 !important;
        border-radius: 12px !important;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        font-family: Montserrat, sans-serif;

        &-info {
            display: flex;
            flex-direction: column;
        }

        &-username {
            color: var(--accent-color);
            font-size: 16px;
            font-weight: 700;
            word-break: break-word;
        }

        &-row {
            font-size: 14px;
            color: var(--accent-color);
            margin-bottom: 2px;
        }

        &-location {
            font-size: 13px;
            font-weight: 600;
            color: #697583;
        }

        &-radio {
            @media (max-width: 480px) {
                display: none !important;
            }
        }
    }
}
</style>